import { Vertical } from '#src/atoms/layout/flex/index.tsx';
import { LabelS } from '#src/atoms/typography/index.tsx';
import { copyright } from '#src/lib/copyright.ts';

import { Socials } from './Socials/index.tsx';

type Props = { copyrightWrapped?: boolean };
export const Footer = ({ copyrightWrapped }: Props) => {
  return (
    <Vertical style={{ maxWidth: copyrightWrapped ? 200 : undefined }}>
      <Socials />
      <LabelS color="var(--c-nd-600)" className="text-center">
        {copyright}
      </LabelS>
    </Vertical>
  );
};
